import { Controller } from 'stimulus'
import Sticky from 'sticky-js'
export default class extends Controller {
  initialize() {
    this.sticky = new Sticky(".sticky-me");
  }
}